"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var configureI18next_1 = __importDefault(require("./configureI18next"));
exports.default = (function (config) { return configureI18next_1.default(config); });
